import { autoMount } from '../../../utils/autoMount';
import { ManagementLogin } from '../../../components/pages/managementLogin';

autoMount({ ManagementLogin });
